import React from 'react';

interface MarqueeProps {
  items?: string[];
  children?: React.ReactNode;
  speed?: number;
  pauseOnHover?: boolean;
  style?: React.CSSProperties;
  className?: string;
}

export const Marquee: React.FC<MarqueeProps> = ({
  items,
  children,
  speed = 28,
  pauseOnHover = false,
  style,
  className,
}) => {
  const content = Array.isArray(items) ? items.join('  ◆  ') : '';

  return (
    <div
      className={`group ${className || ''}`}
      style={{
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maskImage: 'linear-gradient(to right, transparent, black 8%, black 92%, transparent)',
        WebkitMaskImage: 'linear-gradient(to right, transparent, black 8%, black 92%, transparent)',
        ...style,
      }}
    >
      <div
        className={pauseOnHover ? 'group-hover:[animation-play-state:paused]' : ''}
        style={{
          display: children ? 'flex' : 'inline-block',
          width: children ? 'max-content' : undefined,
          paddingLeft: children ? undefined : '100%',
          animation: `marqueeScroll ${speed}s linear infinite`,
        }}
      >
        {children ? (
          <>
            <div className="flex shrink-0 gap-4">{children}</div>
            <div className="flex shrink-0 gap-4">{children}</div>
          </>
        ) : (
          <>{content} &nbsp;&nbsp;◆&nbsp;&nbsp; {content}</>
        )}
      </div>
    </div>
  );
};

export default Marquee;

